export default "__VITE_ASSET__BODIKKJc__"